import * as React from "react";
import { clsx } from "clsx";

import type { TrafficLightRating } from "@/modules/snapshots/businessReports.types";

interface Props {
  rating: TrafficLightRating;
}

const RAG_STATUS_BADGE_CLASSES: Record<TrafficLightRating, string> = {
  RED: "border-[#e7b4ad] bg-[#fde8e6] text-[#a53227]",
  AMBER: "border-[#e7c48a] bg-[#fdf0db] text-[#9a6415]",
  GREEN: "border-[#b7d7c6] bg-[#e6f4ed] text-[#2d7a4f]",
};

const RAG_STATUS_DOT_CLASSES: Record<TrafficLightRating, string> = {
  RED: "bg-[#a53227]",
  AMBER: "bg-[#9a6415]",
  GREEN: "bg-[#2d7a4f]",
};

export const RagStatusBadge: React.FC<Props> = ({ rating }) => (
  <div
    className={clsx(
      "inline-flex h-9 flex-shrink-0 items-center gap-2 rounded-full border px-3.5 text-sm font-bold leading-none",
      "shadow-[0_1px_0_rgba(255,255,255,0.6)] transition-colors",
      RAG_STATUS_BADGE_CLASSES[rating],
    )}
  >
    <span
      aria-hidden="true"
      className={clsx("h-2 w-2 rounded-full ring-[3px] ring-white/55", RAG_STATUS_DOT_CLASSES[rating])}
    />
    <span>RAG: {rating}</span>
  </div>
);
